// 对所有JSBridge方法做统一整理，避免重复需求出现多个相同作用方法

import { callhandler, registerHandler } from "./jsBridge";

/* ------ 注册事件,供APP端调用 ------ */
export const thirdPartyLogins = cb => registerHandler("thirdPartyLogins", cb); // Android应用宝登录事件
export const registJSInitial = cb => registerHandler("registJSInitial", cb); // 初始化数据
export const innerPurchaseFunctionSuc = cb => registerHandler("innerPurchaseFunctionSuc", cb);
export const closeOrderFrame = cb => registerHandler("closeOrderFrame", cb); // 关闭支付窗口
export const checkOrderState = cb => registerHandler("checkOrderState", cb); // 支付结束后返回订单支付状态
export const registYSDKUserUpdate = cb => registerHandler("registYSDKUserUpdate", cb); // Android登录后appid为100000538特殊处理?
export const registFunReportFunction = cb => registerHandler("registFunReportFunction", cb); // 原生支付窗口打开时传递订单信息
export const transferRoleInfo = cb => registerHandler("transferRoleInfo", cb); // 红包活动获取角色信息和sdk活动中获取角色信息，两个地方调用参数不一致
export const transferVoucherData = cb => registerHandler("transferVoucherData", cb); // 代金券界面
export const deviceFlip2H5 = cb => registerHandler("deviceFlip2H5", cb); // h5翻转隐藏悬浮球
export const doKsTaskListener = cb => registerHandler("doKsTaskListener", cb); // $$ 快手临时 监听任务列表变化
export const onTaskErrorListener = cb => registerHandler("onTaskErrorListener", cb); // $$ 快手临时 监听错误信息
export const ksTaskOnResume = cb => registerHandler("ksTaskOnResume", cb); // $$ 快手临时 界面`OnResume`
export const downloadProgress2H5 = cb => registerHandler("downloadProgress2H5", cb); // 盒子下载进度监听
export const onBackPressed2H5 = cb => registerHandler("onBackPressed2H5", cb); // 安卓H5返回键事件
export const notifyDownloadProgress = cb => registerHandler("notifyDownloadProgress", cb); // 下载进度
export const didReceiveMemoryWarning = cb => registerHandler("didReceiveMemoryWarning", cb); // ios内存警报
export const WebFragmentOnResume = cb => registerHandler("WebFragmentOnResume", cb); // 安卓跳转返回事件
export const backGameFromliPa = cb => registerHandler("backGameFromliPa", cb); // 安卓支付宝绑定跳转返回事件
export const getPayInfo = cb => registerHandler("getPayInfo", cb); // 盒子支付页获取支付信息
export const onBackApp = cb => registerHandler("onBackApp", cb); // 盒子支付页从支付宝返回app
export const cloudAppScreenShotCallback = cb => registerHandler("cloudAppScreenShotCallback", cb); // 监听截图刷新事件
export const backFromCloudApp = cb => registerHandler("backFromCloudApp", cb); // 监听安卓从云机返回sdk

// 新增：miracles支付响应
export const miraclesResponse = cb => registerHandler("miraclesResponse", cb); // miracles支付响应
// 新增-wechat登录授权code回调
export const wechatEntryCode = cb => registerHandler("wechatEntryCode", cb); // wechat登录授权code回调

/* ------------------------------- */

/* --------- 调用APP事件 ---------- */
// 通知APP支付成功
export const registFunSuccessReportFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registFunSuccessReportFunction", ...args);
};
// 半原生通知APP关闭当前窗口
export const registReturnGameFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registReturnGameFunction", ...args);
};
// 登陆成功后发送用户信息
export const registLoginVerifySuccessFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registLoginVerifySuccessFunction", ...args);
};
// 注册成功后发送账号密码
export const registScreenShotingFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registScreenShotingFunction", ...args);
};
// android不知道干啥反正有用
export const jsDataStorage = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("jsDataStorage", ...args);
};

// open不等于1时，发送订单参数 token等(内购)
export const registInnerPurchaseFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registInnerPurchaseFunction", ...args);
};
// 通知ios调用第三方库
export const thirdSDKSwitch = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("thirdSDKSwitch", ...args);
};
// 应用宝登录时通知Android应用宝登录方式
export const yybLogin = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("yybLogin", ...args);
};
// 三方渠道登录
export const normalThirdSdkLogin = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("normalThirdSdkLogin", ...args);
};
// 三方渠道-微信登录
export const weChatSdkLogin = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("thirdClientLogin", ...args);
  callhandler("WechatSendAuth", ...args);
};
// 通知创建角色
export const createGameRoleWithRoleId = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("createGameRoleWithRoleId", ...args);
};
// 通知角色升级
export const updateLevelEventWithLevel = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("updateLevelEventWithLevel", ...args);
};
// 通知进入服务器
export const goToGameServerWithRoleId = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("goToGameServerWithRoleId", ...args);
};
// 支付时，支付类型为43调用
export const registSmallProgramFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registSmallProgramFunction", ...args);
};
// 注销时调用
export const registRefreshFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registRefreshFunction", ...args);
};
// 绑定手机成功
export const registBindPhoneVerifySuccess = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registBindPhoneVerifySuccess", ...args);
};
// 
export const registWithinFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registWithinFunction", ...args);
}
//
export const registIDCardVerifySuccess = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registIDCardVerifySuccess", ...args);
}

// 下单成功后调用
export const getOrdersInfo = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getOrdersInfo", ...args);
}

// 支付失败通知
export const registFunFailFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registFunFailFunction", ...args);
}

// 使用浏览器打开链接
export const gameOpenDownloads = (data) => {
  callhandler("gameOpenDownloads", data);
}

// 原生切换账户
export const registLogoutFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registLogoutFunction", ...args);
}

// 防沉迷退出游戏
export const registQuitGameFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registQuitGameFunction", ...args);
}

// 通知客户端关闭防沉迷限制弹窗
export const registFinishedBindIDCardFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registFinishedBindIDCardFunction", ...args);
}

// 闪页通知打开过的id
export const setActionFloatParams = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setActionFloatParams", ...args);
}

// 活动页通知隐藏红点
export const registHiddenRedDotFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registHiddenRedDotFunction", ...args);
}

// 通知客户端保存图片
export const registSaveImgFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registSaveImgFunction", ...args);
}

// 通知ios客户端是否打开悬浮球
export const registShowFloatFunction = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registShowFloatFunction", ...args);
}

// 内购防沉迷通知ios端显示支付webview
export const registSetWindowAlpha = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registSetWindowAlpha", ...args);
}

// 悬浮球弱提醒通知客户端已读文章事件
export const notifyRemindReadArticleId = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("notifyRemindReadArticleId", ...args);
}

// $$ 快手临时 获取任务列表
export const getKsTaskList = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getKsTaskList", ...args);
}

// $$ 快手临时 通知客户端上报任务
export const reportTaskShow = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("reportTaskShow", ...args);
}

// $$ 快手临时 执行任务
export const doKsTask = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("doKsTask", ...args);
}

// $$ 快手临时 获取任务天数
export const getRegisterDay = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getRegisterDay", ...args);
}

// $$ 快手临时 通知快手下发奖励
export const onRequestRewardSuccess = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onRequestRewardSuccess", ...args);
}

// $$ 快手临时 支付成功上报
export const reportUserTopUp = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("reportUserTopUp", ...args);
}

// 盒子游戏 新游推荐打开盒子or下载盒子事件
export const gameDetail2sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("gameDetail2sdk", ...args);
}

// 盒子游戏 领取礼包
export const moreGift2sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("moreGift2sdk", ...args);
}

// 盒子游戏 打开盒子主页面
export const boxMainPage2sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("boxMainPage2sdk", ...args);
}

// 盒子游戏 登录接口请求失败调用
export const boxLoginFail2Sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("boxLoginFail2Sdk", ...args);
}

// 盒子游戏 广告位跳转事件
export const boxSkipAnyPage2Sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("boxSkipAnyPage2Sdk", ...args);
}

// 玩心盒子跳转统一事件
export const skipWXBox2Sdk = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("skipWXBox2Sdk", ...args);
}

// 安卓h5三方通知应用宝退出登录
export const h5GameLogout = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("h5GameLogout", ...args);
}

// 强更下载更新包
export const doDownloadFile = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("doDownloadFile", ...args);
}

// ipv6
export const getOutNetIp = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getOutNetIp", ...args);
}


// ios获取内存信息
export const getDeviceMemoryInfo = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getDeviceMemoryInfo", ...args);
}

// ios h5 存取研发缓存
export const handleNativeStorage = async (data, cb) => {
  callhandler("handleNativeStorage", data, cb);
}

// 个人中心banner跳转盒子事件
export const sendSyDiyIntent = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("sendSyDiyIntent", ...args);
}

// 从客户端主动获取oaid
export const syGetOaid = async (data, cb) => {
  callhandler("syGetOaid", data, cb);
}

// ios h5从客户端获取字段
export const getInitialInfo = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("getInitialInfo", ...args);
}

// 云挂机启动设备
export const tencentCloudAppStartDevice = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("tencentCloudAppStartDevice", ...args);
}

// 云挂机设置设备列表
export const tencentCloudSetDevices = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("tencentCloudSetDevices", ...args);
} 

// 云挂机重启设备
export const tencentCloudAppRestartDevice = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("tencentCloudAppRestartDevice", ...args);
} 

// 盒子支付页 支付成功通知
export const onPaySuccess = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onPaySuccess", ...args);
} 

// 盒子支付页 关闭当前页通知
export const onClosePage = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onClosePage", ...args);
} 

// 盒子支付页 跳转原生页面
export const jumpToNative = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("jumpToNative", ...args);
} 

// 云挂机 刷新
export const tencentCloudAppRefreshDevice = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("tencentCloudAppRefreshDevice", ...args);
} 

// 闪页&活动页 跳转福利页
export const openFloatBall = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("openFloatBall", ...args);
}

// Toast
export const showToast = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("showToast", ...args);
}

// 获取状态栏高度
export const getStatusBarHeight = async (data, cb) => { 
  const args = await handleArguments(data, cb);
  callhandler("getStatusBarHeight", ...args);
}

export const setUserInfo = async (data, cb) => { 
  const args = await handleArguments(data, cb);
  callhandler("setUserInfo", ...args);
}

// 新增：miracles相关方法
// miracles支付
export const miraclesHandler = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("miraclesHandler", ...args);
}

// miracles支付上报
export const miraclesReportHandler = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("miraclesReportHandler", ...args);
}

// 注册上报
export const registerReportHandler = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("registerReportHandler", ...args);
}

// 跳转Safari
export const miraclesopenHandler = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("miraclesopenHandler", ...args);
}

/* ------------------------------- */

const handleArguments = function (data, cb) {
  if (typeof data === "function" && !cb) {
    cb = data;
    data = null;
  }
  return [data, cb];
};
